import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchPorcentajeIvaBienes, useUpdatePorcentajeIvaBienes } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { PORCENTAJEIVABIENES } from '@/shared/interfaces';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';

const returnUrlRBIVA = '/parametrizacion/porcentajes-ret-iva-bienes';

export interface PorcentajeIvaBienesPageInterface {}

const PorcentajeIvaBienesPage: React.FC<PorcentajeIvaBienesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_porcentajeretivabienes);

  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* global state
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* fetch data
  const {
    data: PorcentajeIvaBienesPagingRes,
    isLoading,
    isRefetching,
  } = useFetchPorcentajeIvaBienes({
    page: pageIndex + 1,
    codigo: searchTerm,
  });

  ///* mutations
  const updatePorcentajeIvaBienesMutation = useUpdatePorcentajeIvaBienes({navigate, returnUrl:returnUrlRBIVA});

  ///* handlers
  const onEdit = (original: PORCENTAJEIVABIENES) => {
    navigate(`${returnUrlRBIVA}/editar/${original.id_porcentaje_ret_iva_bienes}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<PORCENTAJEIVABIENES>[]>(
    () => [
    /*   {
        accessorKey: 'codigo',
        header: 'Codigo',
        size: 300,
      }, */
      {
        accessorKey: 'porcentaje',
        header: 'Porcentaje',
        size: 300,
        Cell: ({ row }) => <div>% {row.original.porcentaje}</div>,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={retIvaBienes => {
              if (!hasPermission(PermissionsEnum.api_change_porcentajeretivabienes)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updatePorcentajeIvaBienesMutation.mutate({
                    id: row.original.id_porcentaje_ret_iva_bienes!,
                    data: {
                      ...row.original,
                      estado: retIvaBienes as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Porcentaje de IVA bienes" urlRedirect={`${returnUrlRBIVA}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_porcentajeretivabienes)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Porcentaje de iva bienes" />

      <GeneralTable<PORCENTAJEIVABIENES>
        columns={columns}
        data={PorcentajeIvaBienesPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={PorcentajeIvaBienesPagingRes?.data?.count}
        // // actions
        enableColumnActions={hasPermission(PermissionsEnum.api_change_porcentajeretivabienes)}
        actionsColumnSize={120}
        // crud
        onEdit={onEdit}
        canEdit={hasPermission(PermissionsEnum.api_change_porcentajeretivabienes)}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default PorcentajeIvaBienesPage;
